<template>
  <div>
    请稍等...
  </div>
</template>

<script>
import {queryTemplateDetail} from "@/api/api";

export default {
  components: {},
  data() {
    return {}
  },
  async mounted() {
    //获取url参数
    console.log('code', this.$route.query.code);
    console.log('activityId', this.$route.query.activityId);
    console.log('id', this.$route.query.id);
    
    // 优先处理打卡活动的activityId
    const activityId = this.$route.query.activityId || this.$route.query.id;
    if (activityId) {
      // 跳转到打卡活动页面
      this.$router.push({ path: '/signActivity', query: { activityId: activityId } });
      return;
    }
    
    if (this.$route.query.code) {
      await window.localStorage.setItem('activityCode', this.$route.query.code)
      this.queryTemplateDetailFun(this.$route.query.code)
    }

  },
  methods: {
    queryTemplateDetailFun(code) {
      queryTemplateDetail({activityCode: code}).then(res => {
        console.log(res.data.pagePath)
        //页面跳转
        if (res.data.pagePath) {
          this.$router.push({path: res.data.pagePath})
        } else {
          //提示
          this.$message({
            type: 'info',
            message: '暂无活动'
          });
        }
      })
    },

  },

}
</script>

<style scoped="scoped" lang="less">
</style>
